module.exports = __webpack_public_path__ + "static/img/MV10.497d7a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV10.jpg
// module id = y0Ae
// module chunks = 0